import React from 'react';

import type { Theme, ThemeAlias } from './theme-consts';

export type ThemeContextType = {
  theme: Theme;
  themeAlias: ThemeAlias;
};

export const ThemeContext = React.createContext<ThemeContextType | null>(null);
